export default class ImageModel{
    IdPhotoGenre: string | undefined
    idPhoto: any | undefined
    IdPhotoDocType: string | undefined
    ChopGenre: string | undefined
    Chop: any | undefined
    ChopDocType: string | undefined
    StockistCertGenre: string[] | undefined
    StockistCert: any[] | undefined
    StockistCertDocType: string[] | undefined
    MillCertGenre: string[] | undefined
    MillCert: any[] | undefined
    MillCertDocType: string[] | undefined
    SignatureGenre: string | undefined
    signature: any | undefined
    SignatureDocType: string | undefined
    SignatureGenreSteel: string | undefined
    signatureSteel: any | undefined
    SignatureDocTypeSteel: string | undefined
    SignatureGenreChemistry: string | undefined
    signatureChemistry: any | undefined
    SignatureDocTypeChemistry: string | undefined
    ChopAndSignature: FormData | undefined
}